<div [formGroup]="form" *ngIf="form">
    <mat-table #table [dataSource]="transactions.controls" formArrayName="transactions">
        <ng-container matColumnDef="transfer_type">
            <mat-header-cell *matHeaderCellDef>Transfer Type</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-select placeholder="Transfer Type" formControlName="transfer_type_id">
                        <mat-option *ngFor="let type of transferTypes" [value]="type.id">{{type.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                <mat-form-field class="mat-form-field-fluid">
                    <span matPrefix *ngIf="currency">{{currency}}&nbsp;</span>
                    <input matInput placeholder="Value" formControlName="value"
                        mask="separator.2" thousandSeparator="," />
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                <mat-form-field class="mat-form-field-fluid">
                    <span (click)="datePicker.open()">
                        <input matInput [matDatepicker]="datePicker" readonly
                            placeholder="Date"
                            formControlName="date">
                    </span>
                    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                    <button mat-button
                            *ngIf="row.get('date').value"
                            matSuffix mat-icon-button matTooltip="Clear"
                            (click)="clearDate(row.get('date'))">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-datepicker #datePicker></mat-datepicker>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index">
                <button mat-icon-button
                        color="primary"
                        matTooltip="Add Row"
                        (click)="addRow(i)"
                        type="button">
                    <mat-icon>add_circle</mat-icon>
                </button>
                <button mat-icon-button
                        *ngIf="transactions.length > 1"
                        color="warn"
                        matTooltip="Delete Row"
                        (click)="removeRow(i)"
                        type="button">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-form-field class="mat-form-field-fluid mt-4">
        <textarea matInput rows="3" placeholder="Comment" formControlName="comment"></textarea>
    </mat-form-field>
</div>
